import _ from '@/utils/lodash-optimized'
import React from 'react'
import { connect } from 'react-redux'

import { SystemRoles } from '../../../../../lib/Codes'
import {
  bindTargetMixin,
  CancelButton,
  PractitionerSelectInput,
  SaveButton,
  SelectInput,
  TextInput,
  MaskedTextInput,
  RadioGroupInput
} from '../../../../shared/FormBuilder'
import { Paper } from '../../../../shared/NarusMaterial'

import { CareTeamExtensions } from './constants'

class NarusTeamForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.filterFn = this.filterFn.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.autoAlertLevel = this.autoAlertLevel.bind(this)
    this.fullName = this.fullName.bind(this)
    this.getValue = this.getValue.bind(this)
    this.isNewEntry = this.isNewEntry.bind(this)
    this.setInputValue = this.setInputValue.bind(this)
  }

  componentDidMount () {
    this.setState({ isSubmitting: false }, () => this.validateForm())
  }

  UNSAFE_componentWillMount () {
    const newEntry = this.state.value
    if (this.isNewEntry()) {
      newEntry.pcp = false
    } else {
      newEntry.member = this.fullName()
    }
    this.setState({ value: newEntry })
  }

  validateForm () {
    const {
      value: { id, role, member }
    } = this.state
    let result = false
    if (this.isNewEntry()) {
      result = _.isNil(member) || _.isNil(role)
    } else {
      result = _.isNil(id) || _.isNil(role)
    }

    this.setState({ formInvalid: result })
  }

  getValue () {
    return { ...this.state.value }
  }

  fullName () {
    const v = this.getValue()
      const first = _.capitalize(v?.firstName)
      const last = _.capitalize(v?.lastName)
    return [ last, first ].join(', ')
  }

  isNewEntry () {
    return _.isNil(this.state.value.id)
  }

  handleSubmit () {
    const { onSubmit } = this.props

    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.value && this.state.value) {
      if (prevState.value.role !== this.state.value.role) {
        this.autoAlertLevel()
      }

      if (prevState.value !== this.state.value) {
        this.validateForm()
      }
    }
  }

  autoAlertLevel () {
    const { value } = this.state
    if (value.role === 'nurse_care_manager') {
      this.setInputValue('.alertLevel', 'pcp')
    } else if (value.role === 'medical_director') {
      this.setInputValue('.alertLevel', 'l5')
    } else if (value.role === 'nurse_practitioner') {
      this.setInputValue('.alertLevel', 'l4')
    } else {
      this.setInputValue('.alertLevel', null)
    }
  }

  filterFn (practitioners) {
    const { presentUsers } = this.props
    const presentUserIds = presentUsers.map(u => u.id)
    return practitioners.filter(
      p => p.active && !_.includes(presentUserIds, p.id)
    )
  }

  handleSelect = newVal => {
    if (newVal) {
      const { practitioners } = this.props
      const prac = practitioners.filter(p => p.id === newVal.id)[0]
      const memberRoles = () =>
        prac.role
            .map(role => role?.code?.text)
          .filter(role => !_.isNil(role))
      const rolesArray = SystemRoles.map(role => role.value)
      const memberRole =
        _.first(_.intersection(rolesArray, memberRoles())) || null

      this.setInputValue('.role', memberRole)
      if (_.isEmpty(prac.phone)) {
        this.setInputValue('.phone', undefined)
      } else {
        this.setInputValue(
          '.phone',
            prac?.phone?.[0]?.value ?? ''.replace(/^\+1/g, '')
        )
      }
      this.setInputValue('.member', newVal)
    } else {
      this.setInputValue('.phone', null)
      this.setInputValue('.role', null)
      this.setInputValue('.member', null)
    }
  }

  renderMemberSelectOfTextField () {
    return this.isNewEntry()
      ? (
        <div>
          <PractitionerSelectInput
            name='member'
            label='Member'
            onChange={this.handleSelect}
            filterFn={this.filterFn}
            required
          />
        </div>
      )
      : (
        <TextInput
          label='Member'
          disabled
          name='member'
        />
      )
  }

  render () {
    const { onCancel } = this.props
    return (
      <button
        onKeyDown={this.props.onKeyDown}
        className='margin-top margin-bottom'
      >
        <Paper>
          <div className='row middle-xs middle-sm'>
            <div className='col-xs-12 nh-margin-top-2'>
              <RadioGroupInput
                options={CareTeamExtensions}
                name='alertLevel'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              {this.renderMemberSelectOfTextField()}
            </div>

            <div className='col-xs-12 col-sm-6'>
              <div>
                <SelectInput
                  label='Role'
                  name='role'
                  options={SystemRoles}
                  required
                />
              </div>
            </div>

            <div className='col-xs-12'>
              <div>
                <MaskedTextInput
                  mask='111.111.1111'
                  label='Phone Number'
                  name='phone'
                  disabled
                />
              </div>
            </div>
          </div>

          <div
            className='row end-xs'
            style={{ marginTop: '20px' }}
          >
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={this.state.isSubmitting || this.state.formInvalid}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </button>
    )
  }
}

const mapStateToProps = redux => ({
  practitioners: redux.users.practitioners
})

export default connect(mapStateToProps)(NarusTeamForm)
